import {
  HTTP_SELCOMPANYSPECIAL_FETCHING,
  HTTP_SELCOMPANYSPECIAL_SUCCESS,
  HTTP_SELCOMPANYSPECIAL_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_SELCOMPANYSPECIAL_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_SELCOMPANYSPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_SELCOMPANYSPECIAL_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
